export const locale = {
    lang: 'en',
    data: {
        'VIEW_SETTINGS': {
            'NAVIGATION': 'Navigation:',
            'TOP': 'Top',
            'LEFT': 'Left',
            'RIGHT': 'Right',
            'NAV_FOLD_TITLE': 'Navigation Fold (for vertical navigation):',
            'NAV_FOLD': 'Folded',
            'TOOLBAR': 'Toolbar:',
            'BELOW': 'Below',
            'ABOVE': 'Above',
            'LAYOUT_MODE': 'Layout mode:',
            'BOXED': 'Boxed',
            'FULL_WIDTH': 'Full width',
            'COLORS': 'Colors:',
            'TOOL_BAR_COLOR': 'Toolbar color',
            'NAV_BAR_COLOR': 'Navigation bar color',
            'ROUTER_ANIMATION': 'Router animation:'
        }
    }
};



// WEBPACK FOOTER //
// ./src/@fuse/components/theme-options/i18n/en.ts